module.exports = __webpack_public_path__ + "static/media/hardware-banner4.2fd0fc42.png";